<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      @if(srDetailLoader){
      <app-skeleton-loader
        [formLoader]="true"
        [noOfFields]="5"
      ></app-skeleton-loader>
      } @if(!srDetailLoader){
      <form [formGroup]="form">
        @if (step >= 1) { @if (srNumber && srInprgoressAwating &&
        !srDetailLoader) {
        <app-validation-message
          type="info"
          [content]="{
            title: 'SECTION_NOTES' | translate,
            message: 'SECTION_NOTES_DESCRIPTION' | translate
          }"
          [showbutton]="false"
          [buttonText]="'VIEW_NOTES' | translate"
          (onBtnClick)="showNotes = true"
        />
        }
        <section>
          <h1 class="section-heading">
            {{ "MYSTERY_SHOPPER.SERVICE_REQUEST_DETAILS" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-text-field
                [label]="'MYSTERY_SHOPPER.MEMBERSHIP_NUMBER' | translate"
                [control]="form.get('membershipNumber')!"
              />
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'MYSTERY_SHOPPER.MEMBER_NAME_AR' | translate"
                [control]="form.get('memberNameAr')!"
                [maxlength]="150"
              />
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'MYSTERY_SHOPPER.MEMBER_NAME_EN' | translate"
                [control]="form.get('memberNameEn')!"
                [maxlength]="150"
              />
            </div>
          </div>
        </section>

        <!-- packages detail -->
        <section>
          <h1 class="section-heading">
            {{ "MYSTERY_SHOPPER.MEMBERSHIP_DETAILS_TITLE" | translate }}
          </h1>
          <p class="ltr:pl-3">
            {{ "MYSTERY_SHOPPER.MEMBERSHIP_DETAILS_DESC" | translate }}
          </p>

          <div class="fields-container">
            <!-- Added package list -->
            @if(packages && packages.length > 0){
            <section
              class="border border-dc-navy text-dc-navy divide-y divide-dc-navy"
            >
              <!-- HEADER BAR -->
              <div
                class="flex items-center justify-center px-2 py-4 bg-[#F6F9FA] border-b border-dc-navy"
              >
                <h1 class="font-semibold text-xl">
                  {{ "MYSTERY_SHOPPER.PACKAGE_LIST_TITLE" | translate }}
                </h1>
              </div>
              @for (p of visibleProducts; track p) {
              <div class="relative p-3 sm:p-5 bg-white">
                <div class="grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-4">
                  <div>
                    <p class="text-xs sm:text-sm text-dc-navy!">
                      {{ "MYSTERY_SHOPPER.PACKAGE_TYPE" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">
                      {{ p.packageType ? p.packageType : "-" }}
                    </p>
                    <p class="mt-3 text-xs sm:text-sm text-dc-navy!">
                      {{ "MYSTERY_SHOPPER.BRANCHES" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">
                      {{ p.branches ? p.branches : "-" }}
                    </p>

                    <p class="mt-3 text-xs sm:text-sm text-dc-navy!">
                      {{ "MYSTERY_SHOPPER.VAT_AMOUNT" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">
                      {{ p.vatAmount | number }}
                    </p>
                  </div>
                  <div>
                    <p class="text-xs sm:text-sm text-dc-navy!">
                      {{ "MYSTERY_SHOPPER.CHANNELS" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">
                      {{ p.channels ? p.channels : "-" }}
                    </p>
                    <p class="mt-3 text-xs sm:text-sm text-dc-navy!">
                      {{ "MYSTERY_SHOPPER.QUARTER_TYPE" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">
                      {{ p.quartersType ? p.quartersType : "-" }}
                    </p>

                    <p class="text-xs sm:text-sm text-dc-navy!">
                      {{ "MYSTERY_SHOPPER.TOTAL_AMOUNT" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">
                      {{ p.totalAmount | number }}
                    </p>
                  </div>

                  <div>
                    <p class="text-xs sm:text-sm text-dc-navy!">
                      {{ "MYSTERY_SHOPPER.UNIT_PRICE" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">
                      {{ p.unitPrice | number }}
                    </p>
                    <p class="mt-3 text-xs sm:text-sm text-dc-navy!">
                      {{ "MYSTERY_SHOPPER.QUARTERS" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">{{ p.quarters }}</p>

                    <p class="text-xs sm:text-sm text-dc-navy!">
                      {{ "MYSTERY_SHOPPER.TOTAL_VAT_AMOUNT" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">
                      {{ p.totalVatAmount | number }}
                    </p>
                  </div>

                  @if (showActions) {
                  <div
                    class="flex gap-4 justify-center text-dc-navy mb-3 sm:right-3 sm:mb-0"
                  >
                    <button
                      type="button"
                      class="font-semibold text-lg underline underline-offset-4"
                      (click)="openPackageModal(p)"
                    >
                      {{ "BUTTONS.EDIT" | translate }}
                    </button>
                    <button
                      type="button"
                      class="hover:text-red-600 text-lg underline underline-offset-4"
                      (click)="removePackage(p)"
                      aria-label="Remove"
                    >
                      <i class="fas fa-remove"></i>
                    </button>
                  </div>
                  }
                </div>
              </div>
              }

              <!-- pagination footer --->
              @if (packages.length > 4) {
              <app-pagenation
                [data]="{
                  currentPage: currentPage,
                  totalPages: totalPages,
                  totalItems: packages.length
                }"
                (pageChangeEvent)="loadPage($event)"
              ></app-pagenation>
              }
            </section>
            } @if( form.get('packages')?.touched &&
            form.get('packages')?.hasError('required')){
            <div class="fields-error-container">
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message: 'MYSTERY_SHOPPER.NO_PACKAGES' | translate
                }"
                [showbutton]="false"
              ></app-validation-message>
            </div>
            }

            <div class="flex gap-2">
              @if (showActions) {
              <app-button
                classesName="btn-edge-cut"
                [label]="'MYSTERY_SHOPPER.ADD_PACKAGE' | translate"
                (onBtnClick)="openPackageModal()"
              >
              </app-button>
              }
            </div>
          </div>
        </section>
        }
        <!-- end of package detail -->

        @if (step >= 2) {
        <section class="space-y-4">
          <h1 class="section-heading">
            {{ "DOCUMENTS.TITLE" | translate }}
          </h1>
          <div class="px-2 hidden">
            <p [innerHTML]="'DOCUMENT_NOTE' | translate"></p>
          </div>
          <div class="fields-container">
            @if(loadingDoc){
            <app-skeleton-loader
              [formLoader]="true"
              [noOfFields]="3"
            ></app-skeleton-loader>
            } @if (srFolder && !loadingDoc) { @for (dt of
            srFolder.allowedDocumentTypes; track $index) {
            <div class="field-control">
              <app-file
                #fileCmp
                [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                [control]=""
                [documentType]="dt.nameEn"
                (folderMissing)="openFolder()"
                (onUploadRemove)="(false)"
                [showAction]="showActions"
                [folder]="srFolder"
                [documentServiceType]="documentServiceType.PS"
              ></app-file>
            </div>
            } }
          </div>
        </section>
        } @if (step >= 3) {
        <!-- section for payment method -->
        <section>
          <h1 class="section-heading">
            {{ "SECTION_PAYMENT_METHOD" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-boolean
                [label]="'PAYMENT_METHOD' | translate"
                [control]="form.get('paymentMethod')!"
                [lovType]="lookupKey.PAYMENT_METHOD"
                [labelKey]="'Value'"
                [valueKey]="'Value'"
                (onSelectionChange)="onPaymentMethodChange($event)"
              />
            </div>
            @if ( noAdvancePaymentBalance) {
            <app-validation-message
              [content]="{
                title: 'ALERT.ERROR' | translate,
                message: 'ALERT.NO_ADVANCE_PAYMENT_BALANCE' | translate
              }"
              type="error"
            />
            }
          </div>
        </section>
        }
        <div class="fields-container">
          @if(technicalErrorMsg || errorMsg){
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'VALIDATION_MSG.ERROR' | translate,
              message: errorMsg
                ? errorMsg
                : ('TOAST_MESSAGES.TECHNICAL_ERROR' | translate)
            }"
            [showbutton]="false"
          ></app-validation-message>
          }

          <div class="btn-section buttons-group">
            @if(!formSubmitLoader && showActions){
            <app-button
              classesName="btn-edge-cut btn-width-auto"
              [label]="'BUTTONS.NEXT' | translate"
              (onBtnClick)="nextStep()"
            />
            <app-button
              classesName="card-edge-cut-white btn-width-auto"
              [label]="'BUTTONS.SAVE_CLOSE' | translate"
              (onBtnClick)="saveAndClose()"
            />
            } @if(formSubmitLoader){
            <app-button
              type="button"
              classesName="btn-edge-cut btn-width-auto"
              [label]="'PLEASE_WAIT' | translate"
              [disabled]="true"
            ></app-button>
            }
          </div>
        </div>
      </form>
      }
    </div>
  </div>
</div>

<div>
  <app-service-progress
    [serviceName]="'MYSTERY_SHOPPER.PROGRESS_LABEL' | translate"
    [completePercentage]="formProgress"
  />
</div>

@if (successModal) {
<app-sr-submit-success-modal
  [srNumber]="srNumber"
  (onClose)="closeSuccessModal()"
></app-sr-submit-success-modal>
} @if (showPackageModal) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <button class="modal-x-button" type="button" (click)="closePackageModal()">
      <i class="fas fa-close"></i>
    </button>
    <h1 class="section-heading">
      {{
        editingPackage === null
          ? ("MYSTERY_SHOPPER.PACKAGE_MODAL_TITLE" | translate)
          : ("MYSTERY_SHOPPER.PACKAGE_MODAL_TITLE_EDIT" | translate)
      }}
    </h1>

    <app-add-edit-package
      [form]="packageForm"
      [quarters]="quarters"
      [packagesList]="packagesList"
      [existingPackages]="packages"
      [editingPackage]="editingPackage"
      [isEdit]="editingPackage !== null"
      (save)="savePackage()"
      (cancel)="closePackageModal()"
    />
  </div>
</div>
}

<!-- notes modal -->
@if(showNotes) {
<app-notes
  [srNumber]="srNumber"
  [allowSubmit]="true"
  (onClose)="showNotes = false"
></app-notes>
}
